export default __webpack_public_path__ + "static/media/pwlogo.4d9f523b.svg";